import { IconButton } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SearchIcon from '@mui/icons-material/Search';

const Search = () => {

    const [data, setData] = useState("");

    // ✅ FIXED REDUX ACCESS
    const products = useSelector(state => state?.product?.products || []);

    function onChange(e) {
        setData(e.target.value);
    }

    return (
        <div className="input-container">

            <IconButton>
                <SearchIcon />
            </IconButton>

            <input
                onChange={onChange}
                placeholder="Search for Products, Brands and more"
            />

            <div style={{ backgroundColor: "white", position: "absolute", width: "300px" }}>

                {data &&
                    products
                        .filter(product =>
                            product.title?.toLowerCase().includes(data.toLowerCase())
                        )
                        .map(product => (
                            <div key={product._id}>
                                {product.title}
                            </div>
                        ))
                }

            </div>

        </div>
    );
};

export default Search;